import { Component, ElementRef, Injectable, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateClientSecretRequest } from '../../models/client.model';
import { NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'add-client-secret-modal',
    templateUrl: './add-client-secret.component.html',
    standalone: false
})

export class AddClientSecretModalComponent {

    public clientSecret = new CreateClientSecretRequest();
    // @ViewChild('snfield') serialNumberField: ElementRef;

    public expiresAt: NgbDateStruct;
   // date: { year: number, month: number };

    constructor(public modal: NgbActiveModal) {
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        // this.serialNumberField.nativeElement.focus();
    }

    add() {
        if(this.expiresAt !== null && this.expiresAt !== undefined) {
            this.clientSecret.expiresAt = new Date(this.expiresAt.year, this.expiresAt.month - 1, this.expiresAt.day);
        }
        console.log(this.clientSecret);
        this.modal.close(this.clientSecret);
    }


    cancel() {
        this.modal.dismiss();
    }

}
